import * as React from "react";
import type { SVGProps } from "react";
const SvgWatch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    viewBox="0 0 16 17" {...props}
  >
    <path
      fill="#D6DBE7"
      fillRule="evenodd"
      d="M8 .5a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
      clipRule="evenodd"
    />
    <path
      stroke="#041E78"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 5.523v2.71a.5.5 0 0 0 .223.416l2.01 1.34"
    />
  </svg>
);
export default SvgWatch;
